module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 03 Farma Pasa - Nije li to ludo.eef8f3de.mp3";